var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfluencerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.52 48.7C79.52 61.16 70.58 71.25 59.54 71.25C48.5 71.25 39.57 61.16 39.57 48.7C39.57 36.24 48.51 26.15 59.54 26.15C70.57 26.15 79.52 36.25 79.52 48.7Z",
    fill: "#134263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1 85.9C21.1 85.9 36.57 70.44 41.72 71.72C46.87 73.01 49.88 83.75 59.12 83.75C68.35 83.75 72.59 73.77 75.82 71.65C78.24 70.06 87.66 72.96 98 85.9C98 85.9 84.68 106.95 59.55 106.95C34.42 106.95 21.1 85.9 21.1 85.9Z",
    fill: "#134263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.54 116.08C90.7662 116.08 116.08 90.7662 116.08 59.54C116.08 28.3138 90.7662 3 59.54 3C28.3138 3 3 28.3138 3 59.54C3 90.7662 28.3138 116.08 59.54 116.08Z",
    stroke: "#134263",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.09,
    height: 119.09,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencerIcon);
export default __webpack_public_path__ + "static/media/influencer-icon.2ca6bc164a34da3a6c6d9f190a818abf.svg";
export { ForwardRef as ReactComponent };